import { useMutation } from '@graphcommerce/graphql'
import { AddProductsToCompareListDocument, CompareProductIdInternalFragment, RemoveProductsFromCompareListDocument, useCompareListUidCreate, useCompareSummary } from '@graphcommerce/magento-compare'
import { IconSvg, iconCompare } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Badge, Box, Button, Checkbox, SxProps, Theme } from '@mui/material'
import { useContext, useState } from 'react'

import { ModalContext } from '../../../context/context'
import { useLoading } from '../../../context/loadingContext'
import IconStatsChartSharp from '../../icons/IconStatsChartSharp'
import { AddProductsToCompareSnackbar } from './AddProductsToCompareSnackbar'
import { useCompareMessage } from './CompareMessageProvider'
import SystemMessageContent from './SystemMessageContent'

type CompareProductButtonProps = {
  compare_product_id: number,
  product_name: string;
  product_image_url: string;
  className?: string
}

export function AddToCompareBtn(props: CompareProductButtonProps) {
  const { compare_product_id, product_name, product_image_url, className } = props
  const idString = String(compare_product_id)
  const create = useCompareListUidCreate()
  const compareList = useCompareSummary();
  const { setDisplayMessageBar, setProduct } = useCompareMessage()
  const inCompareList =
    compareList.data?.compareList?.items?.some((i) => i?.uid === idString) ?? false
  const [add] = useMutation(AddProductsToCompareListDocument)
  const [remove] = useMutation(RemoveProductsFromCompareListDocument)
  const { setLoading } = useLoading();
  const useModal = useContext(ModalContext)
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    if (Number(compareList.data?.compareList?.item_count) >= 3) {
      useModal.set && useModal.set({
        content: <SystemMessageContent
          onClose={() => { useModal.close && useModal.close() }}
        />, open: true, title: '', position: 'center', width: 'md:max-w-[600px] !p-0'
      });

      return;
    }
    setLoading(true)
    if (inCompareList) {
      await remove({ variables: { products: [idString], uid: await create() } })
    } else {
      await add({ variables: { products: [idString], uid: await create() } });
      setProduct({
        image_url: product_image_url,
        name: product_name
      });
      setDisplayMessageBar(true);
    }
    setLoading(false);
  }

  return (
    <button
      onClick={handleClick}
      title={inCompareList ? 'حذف از لیست مقایسه' : 'افزودن به لیست مقایسه'}
      className={`w-8 h-8 cursor-pointer rounded-sm  text-light-200 overflow-hidden flex items-center justify-center  ${className} ${inCompareList && '!bg-primary-500'}`} >
      <IconSvg src={iconCompare} size='medium' />

    </button>
  )
}

